import Quote from "../classes/Quote";
import SolarPlant from "../classes/SolarPlant";

var projects = {
  //PROJECTS
  async patch(project) {
    if(window.debug)console.log("dao:saveDevice:")
    const db = window.firebase.firestore();
    var ref = db.collection("databases/" + window.eid + "/projects")
    var e = await ref.doc(project.id.toString()).set(project)
      .then((docRef) => {
        if(window.debug)console.log("Document successfully updated!" + JSON.stringify(docRef));
        return docRef;
      })
      .catch((error) => {
        console.error("Error writing document: ", error);
      });
    return e;

  },
  async upsert(project) {
    var d = JSON.parse(JSON.stringify(project));

    var mppts = {};
    for(a = 0; a< d.solarPlant.mppts.length; a++)
      mppts[a]  = Object.assign({}, d.solarPlant.mppts[a] ) ;
    
    d.solarPlant.mppts = mppts;
    if (d.id) {
      var a = await this.patch(d, window.eid);
      return d;
    }
    var lastId = await this.getLastId(window.eid);
    if(lastId)
        d.id =lastId + 1;
    else   
        d.id = 1;
    await this.setLastId(d.id);

    var today = new Date();
    d.createdAt= today.getTime();
    
    const db = window.firebase.firestore();
    var ref = db.doc("databases/" + window.eid + "/projects/"+ d.id.toString())
    var e = await ref.set(d)
      .then((docRef) => {
        if(window.debug)console.log("Document successfully created!");
        return docRef;
      })
      .catch((error) => {
        console.error("Error writing document: ", error);
      });

    return d;
  },

   async getLastId() {
        const db = window.firebase.firestore();
        let objects = [];
        var docRef = db.doc(`databases/${window.eid}/`)
        var ans = await docRef.get().then((doc) => {
            if (doc.exists) {
                if(window.debug)console.log("Document data:", doc.data());
                return doc.data();
            } else {
                if(window.debug)console.log("No such document!");
            }
        }).catch((error) => {
            if(window.debug)console.log("Error getting document:", error);
        });
        if (ans)
            return ans.lastProjectId;
    },

    async setLastId(value) {
      if(window.debug)console.log("dao:set{lastProjectId:")
      const db = window.firebase.firestore();
      var docRef = db.doc(`databases/${window.eid}`)
      var e = await docRef.update({lastProjectId:value})
      //var ref = db.doc(`databases/${window.eid}/lastProjectId`)
      //var e = await ref.set(value)
          .then((docRef) => {
              if(window.debug)console.log("Document successfully updated!" + JSON.stringify(docRef));
              return docRef;
          })
          .catch((error) => {
              console.error("Error writing document: ", error);
          });
      return e;

  },

  async getAll() {
    if(window.debug)console.log("will get projects")
    const db = window.firebase.firestore();
    let objects = [];
    var  ref = db.collection("databases/" + window.eid + "/projects").orderBy("id","desc") ;
    var ans = await ref
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          objects.push(
            doc.data()
          );
          if(window.debug)console.log(doc.id, " => ", doc.data());
        });
        for (var a = 0; a < objects.length; a++)

          if(window.debug)console.log("will return")
        return objects
      })
      .catch((error) => {
        if(window.debug)console.log("Error getting documents: ", error);
        return error;
      });
    return ans;
  },
  async getFromDealId(dealId) {
    if(window.debug)console.log("will get projects:"+ dealId)
    const db = window.firebase.firestore();
    let objects = [];
    var  ref = db.collection("databases/" + window.eid + "/projects").where("dealId", "==", dealId).orderBy("id","desc") ;
    var ans = await ref
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          objects.push(
            doc.data()
          );
          if(window.debug)console.log(doc.id, " => ", doc.data());
        });
        for (var a = 0; a < objects.length; a++)

          if(window.debug)console.log("will return")
        return objects
      })
      .catch((error) => {
        if(window.debug)console.log("Error getting documents: ", error);
        return error;
      });
    return ans;
  },
    
  async delete( projectId) {
    const db = window.firebase.firestore();
    if(window.debug)console.log("will delete :" + projectId);
    let objects = [];
    var ans = db.collection("databases/" + window.eid + "/projects").doc( projectId.toString())
      .delete()
      .then(() => {
  
          if(window.debug)console.log("Project deleted")
        return "ok"
      })
      .catch((error) => {
        if(window.debug)console.log("Error getting documents: ", error);
        return error;
      });
    return ans;
  },

  async getFromId( projectId) {
    projectId = parseInt(projectId);
    const db = window.firebase.firestore();
    let objects = [];
    var ans = await db.collection("databases/" + window.eid + "/projects").where("id", "==", projectId)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          objects.push(
            doc.data()
          );
          if(window.debug)console.log(doc.id, " => ", doc.data());
        });
        for (var a = 0; a < objects.length; a++)
          if(window.debug)console.log("will return")
        return objects
      })
      .catch((error) => {
        if(window.debug)console.log("Error getting documents: ", error);
        return error;
      });
    if(window.debug)console.log("Try load:" + JSON.stringify(ans))  
    if(ans.length>0){

      //alert(JSON.stringify('trt'))
        var project = ans[0];
        var quote= new Quote();
    
        quote = Object.assign(quote, project.quote)
        
        var solarPlant = new SolarPlant();
        solarPlant.clone(project.solarPlant);
        solarPlant.mppts = Object.keys(solarPlant.mppts).map(i => solarPlant.mppts[i]);
      
        project.quote = quote;
        project.solarPlant = solarPlant;

        ans[0].quote = quote;
        ans[0].solarPlant = solarPlant;
       // alert(JSON.stringify(ans[0].profile))

        if(window.debug)console.log("loaded")
    }
    return ans;
  },

}

export default projects;